import React from 'react';
import {
    Row,
    Spinner
} from 'react-bootstrap';
import '../../styles/Loading.css';
/**
 * Loading takes a message prop that displays under the spinner.
 * @param {Object} props 
 * @returns A loading wheel with given message.
 */
export default function Loading(props) {
    return (
        <div>
            <Row>
                <Spinner 
                    className="loading-spinner"
                    animation="border"
                    role="status">
                </Spinner>
            </Row>
            <div className="loading-text">{props.message}</div>
        </div>
    );
}